export const performanceMarketingCampaignsTypes = {
    'crowdfunding': 'crowdfunding',
    'upcoming': 'upcoming',
    // currently used for Late Pledges and Pledge Manager
    'longTermSales': 'longTermSales',
};

export const navigationActions = {
    extendCampaign: 'extendCampaign',
    adForLast48Hours: 'adForLast48Hours',
};

export const potentialLevels = {
    High: 'High',
    Moderate: 'Moderate',
    Low: 'Low',
};

export const contentAnalysisStatuses = {
    none: 'None',
    pending: 'Pending',
    complete: 'Complete',
    failed: 'Failed',
};

export const locationRestrictedTypes = {
    unlimited: 'Unlimited',
    notAvailableIn: 'NotAvailableIn',
    availableIn: 'AvailableIn',
};

export const performanceMarketingWizardSteps = {
    info: 'info',
    budget: 'budget',
};

export const optimizationTargetTypes = {
    purchase: 'Purchase',
    addToWishlist: 'AddToWishlist',
};

export const budgetSpendingStrategyTypes = {
    linearSpread: 'LinearSpread',
    crowdfundingCampaign: 'CrowdfundingCampaign',
};

export const feeHandlingStrategyTypes = {
    staticPercentageStrategy: 'StaticPercentageStrategy',
    platformTrialStrategy: 'PlatformTrialStrategy',
};

export const catalogCampaignFeeRate = 0.15;

export const customAudienceTypes = {
    gamefoundUsers: 'GamefoundUsers',
    gamefoundUsersLookalikes: 'GamefoundUsersLookalikes',
};

export const targetGroupSourceTypes = {
    autoGenerated: 'AutoGenerated',
    userCreated: 'UserCreated',
};

export const campaignStatusTypes = {
    active: 'Active',
    paused: 'Paused',
    suggestion: 'Suggestion',
};

// Mirrors backend MarketingCampaignType enum (serialized by name).
export const marketingCampaignTypes = {
    dedicatedCampaign: 'DedicatedCampaign',
    catalogCampaign: 'CatalogCampaign',
};

export const assetGroupStatusTypes = {
    active: 'Active',
    paused: 'Paused',
    draft: 'Draft',
};

export const entityEffectiveStatusTypes = {
    draft: 'Draft',
    active: 'Active',
    paused: 'Paused',
    scheduled: 'Scheduled',
    completed: 'Completed',
    inactive: 'Inactive',
};

export const assetReviewStatus = {
    pendingReview: 'PendingReview',
    approved: 'Approved',
    rejected: 'Rejected',
};

export const assetGroupReviewStatus = {
    exempt: 'Exempt',
    rejected: 'Rejected',
    notReady: 'NotReady',
    inReview: 'InReview',
    pendingApproval: 'PendingApproval',
    activable: 'Activable',
};

export const paymentStatus = {
    pending: 'Pending',
    paid: 'Paid',
    failed: 'Failed',
};

export const taxIdValidationStatusTypes = {
    unknown: 'Unknown',
    exempt: 'Exempt',
    reverseCharge: 'ReverseCharge',
    standard: 'Standard',
};

export const assetReviewStatusDisplayName = {
    [assetReviewStatus.pendingReview]: 'Awaiting Review',
    [assetReviewStatus.approved]: 'Approved',
    [assetReviewStatus.rejected]: 'Rejected',
};

export const textAssetTypes = {
    'headline': 'Headline',
    'primaryText': 'PrimaryText',
    'description': 'Description',
};

export const imageAssetTypes = {
    'horizontalImage': 'HorizontalImage',
    'squareImage': 'SquareImage',
    'verticalImage': 'VerticalImage',
    'shortVerticalImage': 'ShortVerticalImage',
};

export const videoAssetTypes = {
    'videoVertical': 'videoVertical',
    'videoSquare': 'videoSquare',
};

export const issuesCodeTypes = {
    ASSETS_PENDING_REVIEW: 'ASSETS_PENDING_REVIEW',
    ASSETS_REJECTED: 'ASSETS_REJECTED',
    LACK_OF_ASSETS: 'LACK_OF_ASSETS',
    NO_ADS: 'NO_ADS',
    LOW_FUNDS: 'LOW_FUNDS',
    NO_FUNDS: 'NO_FUNDS',
    ASSET_GROUP_READY_TO_ACTIVATE: 'ASSET_GROUP_READY_TO_ACTIVATE',
    ALL_ADS_PAUSED: 'ALL_ADS_PAUSED',
};

export const recommendationsCodeTypes = {
    INCREASE_BUDGET: 'INCREASE_BUDGET',
    CREATE_AD_FOR_LAST_48_HOURS: 'CREATE_AD_FOR_LAST_48_HOURS',
    EXTEND_ACTIVE: 'EXTEND_ACTIVE',
};

export const expectedFundingConversionFactors = {
    crowdfunding: 0.05,
    nonCrowdfunding: 0.0075,
};

export const marketingCampaignConstants = {
    MAX_DURATION_IN_DAYS: 90,
};

export const suggestionCampaignSteps = {
    suggestion: 'suggestion',
    wizard: 'wizard',
    summary: 'summary',
    payment: 'payment',
};

export const defaultSuggestionCampaignStep = suggestionCampaignSteps.suggestion;

export const OUTDATED_SUGGESTION_CAMPAIGN_DATES_MESSAGE
    = 'The scheduled dates for this Easy Campaign have passed. Edit the campaign details to set new dates.';

export const adMediaAssetModalModes = {
    add: 'add',
    edit: 'edit',
};

export const previewImagesTypes = {
    Square: 'square',
    Vertical: 'vertical',
    Horizontal: 'horizontal',
    ShortVertical: 'shortVertical',
};

export const previewVideoTypes = {
    Vertical: 'vertical',
    Square: 'square',
};

export const previewOriginFormatTypes = {
    Feeds: 'Feeds',
    StoriesAndReels: 'Stories and Reels',
    RightColumn: 'Right column',
};

export const previewFormatTypes = {
    FacebookDesktopRightColumn: 'FacebookDesktopRightColumn',
    FacebookMobileFeed: 'FacebookMobileFeed',
    InstagramMobileFeed: 'InstagramMobileFeed',
    MetaReels: 'MetaReels',
    MetaStories: 'MetaStories',
    LegacyFacebookDesktopRightColumn: 'LegacyFacebookDesktopRightColumn',
};

export const ThumbLayoutTypes = {
    Stacked: 'Stacked',
    SideBySide: 'SideBySide',
};

export const previewFilenameKeys = {
    horizontalFilename: 'horizontalFilename',
    squareFilename: 'squareFilename',
    verticalFilename: 'verticalFilename',
    shortVerticalFilename: 'shortVerticalFilename',
};

export const adTypes = {
    last48HoursAd: 'last48HoursAd',
    newAd: 'newAd',
};

export const accountTypes = {
    business: 'Business',
    individual: 'Individual',
};

export const feedbackTypes = {
    negative: 'negative',
    positive: 'positive',
    none: 'none',
};

export const SupportedImageFormats = {
    Horizontal: 'Horizontal',
    ShortVertical: 'ShortVertical',
    Vertical: 'Vertical',
    Square: 'Square',
};

export const InvoicePaymentStatusTypes = {
    unpaid: 'Unpaid',
    paid: 'Paid',
};

export const PaymentType = {
    Money: 'Money',
    Credits: 'Credits',
};

export const ContentOrigin = {
    UserProvided: 'UserProvided',
    Suggestion: 'Suggestion',
    ModifiedSuggestion: 'ModifiedSuggestion',
    ProductCatalogImport: 'ProductCatalogImport',
};

export const InvoiceCategoryDisplayNames = {
    TopUp: 'Top-up',
    FeesAndTaxes: 'Fees and taxes',
};

export const targetGroupBlockKinds = {
    customAudience: 'customAudience',
    interest: 'interest',
};